import { useTranslations } from "use-intl";

import { Label } from "@lawline/ui/components/label";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@lawline/ui/components/select";

import { LOCALE_LABELS, LOCALES, type Locale } from "@platform/core/i18n/config";
import { useLocaleSwitcher } from "@platform/core/i18n/context";

export function LanguageSection() {
	const t = useTranslations("settings.language");
	const { locale, setLocale } = useLocaleSwitcher();

	return (
		<section className="flex flex-col gap-6">
			<div className="flex flex-col gap-2">
				<Label htmlFor="language">{t("label")}</Label>
				<Select value={locale} onValueChange={(value) => setLocale(value as Locale)}>
					<SelectTrigger id="language" className="w-50">
						<SelectValue placeholder={t("placeholder")} />
					</SelectTrigger>
					<SelectContent>
						{LOCALES.map((value) => (
							<SelectItem key={value} value={value}>
								{LOCALE_LABELS[value]}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>
		</section>
	);
}
